<template>
  <div>
    <TableVisualizationLayout :leftInfo="leftInfo" :leftAction="leftAction">
      <template #headerContent>
        <b-col class="pl-0 pr-0 admin-filter">
          <b-row class="mt-4 mb-4" align-h="between">
            <b-col class="pl-0 pr-0" sm="4">

               <b-form-input
                  debounce="500"
                  v-model.lazy.trim="filterTitle"
                  class="input-key-word magnify"
                  placeholder="Busque por nome do treinamento ou certificado…"
                  type="search"
                />
            </b-col>
            <b-col class="pl-0 pr-0 text-right" sm="4">
              <b-select v-model="filterTypeId" :options="filterTypes" />
            </b-col>
          </b-row>
        </b-col>
      </template>
      <template #table>
        <div class="scrollme">
          <b-table
            class="admin table-custom-cooperado spaced-text"
            :fields="fields"
            :items="items"
            v-show="!loading"
            show-empty
            empty-text="Nenhuma informação para exibir!"
          >
            <template #cell(trainingName)="data">
              <TruncateText :text="data.item.trainingName"></TruncateText>
            </template>
            <template #cell(actions)="data">
              <div
                class="d-flex justify-content-center"
                v-if="!data.item.linkId"
              >
                <div
                  class="icon custom-icon-link"
                  @click="goForm(data.item)"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Vincular certificado"
                ></div>
            </div>
              <div
                class="d-flex justify-content-center"
                v-if="data.item.linkId"
              >
                <div
                  class="icon custom-icon-edit"
                  @click="goForm(data.item)"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Editar"
                ></div>
              </div>
            </template>
          </b-table>
        </div>
        <div v-show="loading">
          <b-skeleton-table :rows="10" :columns="6"></b-skeleton-table>
        </div>
      </template>
      <template #footerContent>
        <div
          class="d-flex bd-highlight mb-3 justify-content-between"
          :class="isMobile() ? 'flex-column-reverse' : 'flex-row'"
          style="width: 100%"
        >
          <div
            class="mx-auto"
            :class="isMobile() ? '' : 'pagination-cerificate align-self-center'"
          >
            <b-pagination
              v-model="page"
              :total-rows="totalSize"
              :per-page="perPage"
              aria-controls="my-table"
              size="lg"
            />
          </div>
        </div>
      </template>
    </TableVisualizationLayout>
    <success-modal
      ref="success-modal"
      :description="msgSuccess"
      buttonText="Ok, entendi!"
    />
  </div>
</template>

<script>
import _ from "lodash";
import TableVisualizationLayout from "../../../layouts/TableVisualizationLayout.vue";
import {
  dateToLocaleDateString,
  dateToTime,
} from "../../../utils/date/date-utils";
import RoutesPaths from "../../../router/router-structure/routes-paths";
import { resolve_path_url } from "../../../utils/image/image-utils";
import { isMobile } from "../../../utils/mobile/mobile";

import { getLink } from "../../../services/link-cretificate-training/linkCertificateTrainingService";

import SuccessModal from "../../../components/base-modals/SuccessModal.vue";
import TruncateText from "../../../components/truncate-text/TruncateText.vue";

export default {
  components: {
    TableVisualizationLayout,
    SuccessModal,
    TruncateText,
  },
  mounted() {
    this.getLinks();
  },
  computed: {
    shouldFetchData() {
      return this.filterTitle.length > 2 || this.filterTitle.length == 0;
    },
  },
  watch: {
    page: {
      handler() {
        this.getLinks();
      },
    },
    filterTypeId: {
      handler() {
        this.getLinks();
      },
    },
    filterTitle: {
      handler: _.debounce(function () {
        if (this.shouldFetchData) {
          this.getLinks();
        }
      }, 500), // Espera 500ms antes de chamar a função
      immediate: false,
    },
  },
  data() {
    return {
      filterTypes: [
        { value: "ALL", text: "TODOS" },
        { value: "TRAINING_WITHOUT_LINK", text: "TREINAMENTOS SEM VÍNCULOS" },
        { value: "CURRENT", text: "VÍNCULOS VIGENTES" },
        { value: "FUTURE", text: "VÍNCULOS FUTUROS" },
        { value: "FINISHED", text: "VÍNCULOS FINALIZADOS" },
      ],
      filterTypeId: "ALL",
      filterTitle: "",
      page: 1,
      perPage: 10,
      totalSize: 10,
      itemToDelete: {},
      itemToUpdateStatus: {},
      statusUpdate: null,
      textModalUpdateStatus: null,
      textConfirm: null,
      msgSuccess: "",
      leftAction: {
        text: "Vínculos entre Treinamentos e Certificados",
        onClick: this.leftActionClickHandler,
      },
      leftInfo: "",
      fields: [
        {
          key: "trainingName",
          label: "Treinamento",
          thStyle: { width: "35%" },
        },
        {
          key: "certificateName",
          label: "Certificado vigente",
          thStyle: { width: "15%" },
        },
        {
          key: "initialDateLink",
          label: "Data início do vínculo",
          class: "text-right",
          thStyle: { width: "14%" },
        },
        {
          key: "endDateCertificate",
          label: "Data fim do certificado",
          class: "text-right",
          thStyle: { width: "14%" },
        },
        {
          key: "endDateTraining",
          label: "Data fim do treinamento",
          class: "text-right",
          thStyle: { width: "14%" },
        },
        {
          key: "actions",
          label: "Ações",
          class: "text-center",
          thStyle: { width: "8%" },
        },
      ],
      items: [],
      loading: true,
      resolve_path_url,
    };
  },
  methods: {
    isMobile: isMobile,
    async encodeStr(id) {
      const response = btoa(id);
      return response;
    },
    goForm(item) {
      this.$router.push({
        path: RoutesPaths.linkCertificationTrainingManagement.form(
          item?.trainingId
        ),
      });
    },
    async getLinks() {
      try {
        this.loading = true;
        const linkResponse = await getLink(
          this.filterTypeId,
          this.filterTitle,
          this.page - 1,
          this.perPage
        );

        this.items = linkResponse.items;
        this.totalSize = linkResponse.totalItems;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.error("getInformation", error);
      }
    },
    leftActionClickHandler() {
      this.$router.go(-1);
    },
    onFormatDate(value) {
      let valueSplit = value.split(" ");
      let horaSplit = valueSplit[1].split(":");
      return `${valueSplit[0]} às ${horaSplit[0]}h${horaSplit[1]}`;
    },
    dateToTime: dateToTime,
    dateToLocaleDate: dateToLocaleDateString,
  },
};
</script>
<style lang="scss">
  @import '@/assets/styles/scss/components/_table.scss';
</style>
<style lang="scss" scoped>
  @import '@/assets/styles/scss/components/_form-filter.scss';
.flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
}


.custom-actions {
  width: 90%;
}

.icon {
  padding: 1.4rem;
}
.custom-icon-link {
  background-image: url("../../../assets/icons/link-outline.svg");
  background-repeat: no-repeat;
  width: 32px;
  height: 25px;
  border-radius: 30px;
  background-position: center;
  cursor: pointer;
  &:hover {
    background: rgba(1, 157, 95, 0.1) 0% 0% no-repeat padding-box;        
    background-position: center;
    background-image: url("../../../assets/icons/link-outline.svg");       
  }
}

.custom-icon-edit {
  background-image: url("../../../assets/icons/pencil-outline.svg");
  background-repeat: no-repeat;
  width: 32px;
  height: 25px;
  border-radius: 30px;
  background-position: center;
  cursor: pointer;
  &:hover {
    background: rgba(1, 157, 95, 0.1) 0% 0% no-repeat padding-box;
    background-image: url("../../../assets/icons/pencil-outline-houver.svg");
    background-position: center;
  }
}

.custom-actions div:not(:last-child) {
  margin-right: 1.2rem;
}
.pagination-cerificate ul {
  margin-bottom: 0rem;
}
.scrollme {
  overflow-x: auto;
}
</style>
